import React from "react";
import { Api } from '../../api/Api';
import { Link, NavLink } from "react-router-dom";
import { Helmet } from "react-helmet";
import FadeInOut from "../../tools/FadeInOut";
import { FrontUrl } from "../../api/FrontUrl";
import { ServerUrl } from '../../api/ServerUrl';
import "./LandingPgae.css";
import { useState, useEffect } from "react";
import { useLang } from "../../../context/LangContext";
import swal from "sweetalert";





const httpFrontCPage = FrontUrl;
const HERO_SHOES = `${httpFrontCPage}/assets/images/landingpage/Shoe-picture.png`;
const TGA = `${httpFrontCPage}/assets/images/landingpage/OrthoGenix-TGA-Approve-Sticker-transperent.png`;





const PRODUCT1 =
  "https://footbalancetech.com/footserver/public/backend/img/product/9B1aC-1716107642-Product.jpg";
const PRODUCT2 =
  "https://footbalancetech.com/footserver/public/backend/img/product/aSshT-1716107322-Product.jpg";
const PRODUCT3 =
  "https://footbalancetech.com/footserver/public/backend/img/product/iRgC2-1713958162-Product.jpg";

const DOCTOR_IMAGE =
  "https://footbalancetech.com/footserver/public/backend/img/pages/about/1715403400-image.jpg";

const Index = () => {
  const { lang, setLang } = useLang();

  const { http } = Api();
  // landing page main info
  const [landingdata, setLandingData] = useState(null);

  // landing services list
  const [servicesData, setServicesData] = useState([]);

  // landing services list
  const [productsData, setProducts] = useState([]);

  useEffect(() => {
    let mounted = true;

    http.get('/landing-page-info')
      .then(res => {
        if (!mounted) return;
        setLandingData(res.data?.data ?? null);
      })
      .catch(error => {
        console.error('Landing Info Fetch Error:', error);
      });

    return () => { mounted = false; };
  }, []);

  // 🔥 NEW: Get Landing Services
  useEffect(() => {
    let mounted = true;

    http.get('/landing-page-services')
      .then(res => {
        if (!mounted) return;
        setServicesData(res.data?.data ?? []);
        console.log("landing services →", res.data?.data);
      })
      .catch(error => {
        console.error('Service Fetch Error:', error);
      });
    return () => { mounted = false; };
  }, [])


  // 🔥 NEW: Get Landing Products
  useEffect(() => {
    let mounted = true;

    http.get('/landing-page-products')
      .then(res => {
        if (!mounted) return;
        setProducts(res.data?.data ?? []);
        console.log("landing products →", res.data?.data);
      })
      .catch(error => {
        console.error('Product Fetch Error:', error);
      });

    return () => { mounted = false; };
  }, [])





  const [loading, setLoading] = useState(false);
  // --- safer, simpler hero title selection ---
  const payload = landingdata ?? {};

  // HERO (titles)
  const heroTitle1 = (lang === 'en')
    ? (payload.b_title1_en ?? payload.b_title1_bn ?? '')
    : (payload.b_title1_bn ?? payload.b_title1_en ?? '');

  const heroTitle2 = (lang === 'en')
    ? (payload.b_title2_en ?? payload.b_title2_bn ?? '')
    : (payload.b_title2_bn ?? payload.b_title2_en ?? '');

  const heroTitle3 = (lang === 'en')
    ? (payload.b_title3_en ?? payload.b_title3_bn ?? '')
    : (payload.b_title3_bn ?? payload.b_title3_en ?? '');

  // HERO image
  const heroImageSrc = payload.b_image ? `${ServerUrl}/backend/img/${payload.b_image}` : null;
  const heroImageAlt = payload.b_alt ?? '';

  // TGA (HTML text + image)
  const tgaText = (lang === 'en') ? (payload.t_title_en ?? '') : (payload.t_title_bn ?? '');
  const tgaImageSrc = payload.t_image ? `${ServerUrl}/backend/img/${payload.t_image}` : null;
  const tgaImageAlt = payload.t_alt ?? '';

  // ABOUT (HTML + image)
  const aboutHtml = (lang === 'en') ? (payload.a_title_en ?? '') : (payload.a_title_bn ?? '');
  const aboutImageSrc = payload.a_image ? `${ServerUrl}/backend/img/${payload.a_image}` : null;
  const aboutImageAlt = payload.a_alt ?? '';

  // DOCTOR
  const doctorName = (lang === 'en') ? (payload.d_name_en ?? '') : (payload.d_name_bn ?? '');
  const doctorDesignation = (lang === 'en') ? (payload.d_designation_en ?? '') : (payload.d_designation_bn ?? '');
  const doctorTitle = (lang === 'en') ? (payload.d_title_en ?? '') : (payload.d_title_bn ?? '');
  const doctorDescHtml = (lang === 'en') ? (payload.d_description_en ?? '') : (payload.d_description_bn ?? '');
  const doctorImageSrc = payload.d_image ? `${ServerUrl}/backend/img/${payload.d_image}` : null;
  const doctorImageAlt = payload.d_alt ?? '';

  // WHO / Pedorthist section (HTML)
  const whoHtml = (lang === 'en') ? (payload.p_title_en ?? '') : (payload.p_title_bn ?? '');




  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    interest: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.name || !form.phone || !form.interest) {
      swal("Oops!", "Please fill all required fields", "warning");
      return;
    }
    setLoading(true);
    try {
      const res = await http.post("/interest-store", form);

      if (res.data.success) {
        swal({
          title: "Thank you for your interest!",
          content: {
            element: "div",
            attributes: {
              innerHTML: `
              <div style="text-align:center; font-size:15px; line-height:1.7;">
                <p>Your interest has been submitted successfully.</p>
                <p>We will contact you soon.</p>
              </div>
            `
            }
          },
          icon: "success",
          timer: 30000,
          buttons: true,
        });

        setForm({
          name: "",
          phone: "",
          email: "",
          interest: "",
        });
      }
    } catch (error) {
      swal("Error", "Something went wrong", "error");
    } finally {
      setLoading(false);
    }
  }



  return (
  <div className={`fb-landing ${lang === 'bn' ? 'bn-font' : 'en-font'}`}>
      <Helmet>
        <title>Foot Balance Technology BD</title>
      </Helmet>

      {/* ====== HERO ====== */}

      <section className="fb-hero">
        <div className="container fb-hero-inner">
          <div className="fb-hero-text">
            <FadeInOut>
              <h1 className="fb-hero-title">
                {heroTitle1} <br />
                <span> {heroTitle2} </span>
                <br />
                <span className={lang === "en" ? "hero-title3-en" : "hero-title3-bn"}>
                  {heroTitle3}
                </span>
              </h1>
            </FadeInOut>

            <div
              className="fb-hero-cta"
              style={{
                position: "relative",
                display: "inline-block",
              }}
            >
              <select
                value={lang}
                onChange={(e) => setLang(e.target.value)}
                className="fb-btn-primary"
                style={{
                  padding: "10px 20px",
                  paddingRight: "45px",
                  cursor: "pointer",
                  border: "1px solid #ffffff55",
                  borderRadius: "10px",
                  backdropFilter: "blur(8px)",
                  color: "#fff",
                  fontSize: "15px",
                  fontWeight: "500",
                  appearance: "none",
                  WebkitAppearance: "none",
                  MozAppearance: "none",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                  transition: "0.3s",
                }}
              >
                <option value="bn">বাংলা</option>
                <option value="en">English</option>
              </select>

              <span
                style={{
                  position: "absolute",
                  right: "18px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                  fontSize: "14px",
                  color: "#fff",
                  opacity: 0.9,
                }}
              >
                ▼
              </span>
            </div>

          </div>
          <FadeInOut>

            <div className="fb-hero-image">
              <img src={heroImageSrc} alt={heroImageAlt} />
            </div>
          </FadeInOut>
        </div>


        <div className="container">
          <div className="fb-hero-cta text-center mt-5">
            <Link
              to={landingdata?.hero_cta_link ?? "/book-appointment"}
              className="fb-btn-primary bold px-5"
            >
              {landingdata?.hero_cta_text ??
                (lang === "bn"
                  ? "আপনার অ্যাপয়েন্টমেন্ট বুক করুন"
                  : "Book Your Appointment")}
            </Link>
          </div>
        </div>
      </section>



      <section className="fb-section fb-tga fb-tga-text py-5">
        <div className="container fb-tga-inner">
          <div className="row">
            <div className="col-lg-10 m-auto ">
              <div className="row align-items-center">
                <h2 className="fw-bold text-center text-danger mb-3">
                  {lang === "bn" ? "টিজিএ অনুমোদিত" : "TGA Approved"}
                </h2>

                {/* col-lg-9 */}
                <div className="col-lg-10 col-md-12 mb-4 mb-lg-0">
                  <p
                    dangerouslySetInnerHTML={{
                      __html: tgaText
                    }}
                  ></p>
                </div>

                {/* col-lg-3 */}
                <div className="col-lg-2 col-md-12 text-center">
                  <img src={tgaImageSrc} alt={tgaImageAlt} className="img-fluid tga" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>



      {/* ====== ABOUT US ====== */}
      <section className="fb-section fb-about">
        <div className="container fb-about-inner">
          <h2>
            {lang === "bn" ? "আমাদের সম্পর্কে" : "About Us"}
          </h2>

          <p
            dangerouslySetInnerHTML={{
              __html: aboutHtml
            }}
          ></p>
          <div className="fb-center-cta mt-5">
           <Link to="/faq" className="fb-btn-primary">
            {lang === "bn" ? "প্রায়শই জিজ্ঞাসিত প্রশ্নাবলি (FAQ)" : "Frequently Asked Questions"}
          </Link>

          </div>
        </div>


      </section>

      {/* ====== OUR SERVICES (Dynamic) ====== */}
      <section className="fb-section fb-services">
        <div className="container">
          <h2 className="fb-section-title">
            {lang === "bn" ? "আমাদের সার্ভিস সমূহ" : "Our Services"}
          </h2>


          <div className="row">

            {servicesData.length > 0 ? (
              servicesData.map((item) => (
                <div className="col-lg-3 col-md-4 col-sm-6 mb-4" key={item.id}>
                  <Link to={`/service/${item.slug}`} className="fb-service-card">

                    <div className="fb-service-icon">
                      <img
                        src={`${ServerUrl}/backend/img/services/${item.image}`}
                        alt={item.alt}
                        className="img-fluid"
                      />
                    </div>



                    <p>
                      {lang === "en" ? item.title : item.title_b}
                    </p>

                  </Link>
                </div>
              ))
            ) : (
              <p className="text-center">Loading services...</p>
            )}

          </div>
        </div>
      </section>


      {/* ====== OUR PRODUCTS ====== */}
      <section className="fb-section fb-products">
        <div className="container">
         <h2 className="fb-section-title">
          {lang === "bn" ? "আমাদের প্রোডাক্ট সমূহ" : "Our Products"}
        </h2>


          <div className="row">

            {/* 1 */}
            <div className="col-lg-3 col-md-4 mb-4">
              <div className="fb-product-card">
                <img src={HERO_SHOES} alt="Customised Orthopedic Footwear" />
              <h3>
                {lang === "bn"
                  ? "কাস্টমাইজড অর্থোপেডিক ও ডায়াবেটিক ফুটওয়্যার"
                  : <>Customised Orthopedic <br /> & Diabetic Footwear</>
                }
              </h3>


                {/* Appointment */}
                <Link to="/book-appointment" className="fb-btn-primary small">
                  {lang === "bn"
                    ? "অ্যাপয়েন্টমেন্ট বুক করুন"
                    : "Book Your Appointment"}
                </Link>

              </div>
            </div>

            {/* 2 */}
            <div className="col-lg-3 col-md-4 mb-4">
              <div className="fb-product-card">
                <img
                  src={`${httpFrontCPage}/assets/images/landingpage/Insole.png`}
                  alt="Customised Orthotic Insole"
                />
                <h3>
                  {lang === "bn"
                    ? "কাস্টমাইজড অর্থোটিক ইনসোল"
                    : <>Customised Orthotic <br /> Insole</>
                  }
                </h3>

                {/* Appointment */}
                <Link to="/book-appointment" className="fb-btn-primary small">
                  {lang === "bn"
                    ? "অ্যাপয়েন্টমেন্ট বুক করুন"
                    : "Book Your Appointment"}
                </Link>
              </div>
            </div>

            {/* 3 */}
            <div className="col-lg-3 col-md-4 mb-4">
              <div className="fb-product-card">
                <img
                  src={`${httpFrontCPage}/assets/images/landingpage/Shoe.jpg`}
                  alt="Medical Grade Footwear"
                />

                <h3>
                  {lang === "bn"
                    ? "মেডিকেল গ্রেড ফুটওয়্যার"
                    : <>Medical Grade <br /> Footwear</>
                  }
                </h3>


                {/* Call for price */}
                <a href="tel:+8801944003077" className="fb-btn-primary small">
                  {lang === "bn" ? "মূল্য জানতে ফোন করুন" : "Call for Price"}
                </a>

              </div>
            </div>

            {productsData.length === 0 && (
              <p className="text-center w-100">No products found</p>
            )}

            {productsData.map(product => {
              const image =
                product.images && product.images.length > 0
                  ? ServerUrl + product.images[0].image
                  : httpFrontCPage + '/assets/images/no-image.png';

              return (
                <div className="col-lg-3 col-md-4 mb-4" key={product.id}>
                  <div className="fb-product-card">
                    <img src={image} alt={product.product_name} />

                    <h3>{product.product_name}</h3>

                    <p className="fb-product-price">
                      {product.price ? `${parseFloat(product.price)} /-` : 'Price N/A'}
                    </p>

                    <Link
                      to={`/explore-product/${product.slug}`}
                      className="fb-btn-primary small"
                    >
                      Buy Now
                    </Link>
                  </div>
                </div>
              );
            })}

          </div>
        </div>
      </section>





      {/* ====== DOCTOR / PEDORTHIST ====== */}
      <section className="fb-section fb-doc">
        <div className="fb-container">
          <div className="fb-doc-inner">

            <div className="fb-doc-photo">
              <img src={doctorImageSrc} alt={doctorImageAlt} />
            </div>

            <div className="fb-doc-text">
              <h3 className="fb-doc-name">{doctorName}</h3>
              <p className="fb-doc-title">{doctorDesignation}</p>

              <p className="fb-doc-subtitle">
                {doctorTitle}
              </p>

              <p className="fb-doc-desc"
                dangerouslySetInnerHTML={{
                  __html: doctorDescHtml
                }}
              ></p>


              <Link to="/about/mr-mahmudul-hasan-deenar" className="fb-btn-primary mt-2"> {lang === "bn" ? "বিস্তারিত" : "Read More"}</Link>
            </div>
          </div>
        </div>
      </section>


      {/* ====== WHO IS A PEDORTHIST ====== */}
      <section className="fb-section fb-who">
        <div className="fb-container">
          <h2 className="fb-section-title mb-4">
           {lang === "bn" ? "পেডোর্থিস্ট সম্পর্কে জানুন" : "Who is a Pedorthist?"}
          </h2>

          <div className="fb-doc-inner p-0">
            <p className="fb-doc-desc"
              dangerouslySetInnerHTML={{
                __html: whoHtml
              }}
            ></p>
            <Link to="/book-appointment" className="fb-btn-primary mt-2">
               {lang === "bn"
                    ? "অ্যাপয়েন্টমেন্ট বুক করুন"
                    : "Book Your Appointment"}
            </Link>
          </div>
        </div>
      </section>

      {/* ====== FORM SECTION ====== */}
<section className="fb-section fb-interest-form fb-form">
  <div className="container">
    <div className="fb-form-card mx-5">

      <h2 className="fb-section-title mb-4">
        {lang === "bn"
          ? "আপনার আগ্রহ সম্পর্কে আমাদের জানান"
          : "Submit Your Interest"}
      </h2>

      <form onSubmit={handleSubmit}>
        <div className="row">

          {/* Full Name */}
          <div className="col-lg-6 mb-3">
            <label className="form-label fw-semibold">
              {lang === "bn" ? "পুরো নাম" : "Full Name"}{" "}
              <span className="text-danger">*</span>
            </label>
            <input
              className="fb-input"
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder={
                lang === "bn"
                  ? "আপনার পুরো নাম লিখুন"
                  : "Enter your full name"
              }
            />
          </div>

          {/* Phone Number */}
          <div className="col-lg-6 mb-3">
            <label className="form-label fw-semibold">
              {lang === "bn" ? "মোবাইল নম্বর" : "Phone Number"}{" "}
              <span className="text-danger">*</span>
            </label>
            <input
              type="number"
              className="fb-input"
              name="phone"
              value={form.phone}
              onChange={handleChange}
              placeholder={
                lang === "bn"
                  ? "০১XXXXXXXXX"
                  : "01XXXXXXXXX"
              }
            />
          </div>

          {/* Email */}
          <div className="col-lg-12 mb-3">
            <label className="form-label fw-semibold">
              {lang === "bn" ? "ইমেইল (ঐচ্ছিক)" : "Email (optional)"}
            </label>
            <input
              type="email"
              className="fb-input"
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="example@gmail.com"
            />
          </div>

          {/* Interest */}
          <div className="col-lg-12 mb-3">
            <label className="form-label fw-semibold">
              {lang === "bn" ? "আপনি কোন বিষয়ে আগ্রহী" : "Your Interest"}{" "}
              <span className="text-danger">*</span>
            </label>
            <textarea
              className="fb-input"
              name="interest"
              rows="3"
              value={form.interest}
              onChange={handleChange}
              placeholder={
                lang === "bn"
                  ? "সংক্ষেপে আপনার আগ্রহের বিষয়টি লিখুন"
                  : "Write briefly about your interest"
              }
            ></textarea>
          </div>

        </div>

        <button
          type="submit"
          className="fb-btn-primary fb-submit-btn"
          disabled={loading}
        >
          {loading ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
              ></span>
              {lang === "bn" ? "সাবমিট করা হচ্ছে..." : "Submitting..."}
            </>
          ) : (
            lang === "bn" ? "সাবমিট করুন" : "Submit"
          )}
        </button>

      </form>
    </div>
  </div>
</section>

    </div>
  );
};

export default Index;
